import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  // ── La pornire, verifică dacă există token și încarcă userul
  useEffect(() => {
    const token = localStorage.getItem("narratiq_token");
    if (token) {
      fetchMe(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchMe = async (token) => {
    try {
      const res = await fetch(`${API}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setUser(data.user);
        setSubscription(data.subscription);
      }
    } catch {
      // eroare de rețea — ignorăm
    } finally {
      setLoading(false);
    }
  };

  // ── Login — userul vine direct din răspuns, fără fetchMe
  const login = async (email, password) => {
    try {
      const res = await fetch(`${API}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) return data.error || "Eroare la autentificare.";

      if (data.token) {
        localStorage.setItem("narratiq_token", data.token);
        setUser(data.user);
        setSubscription(null);
      }
      return null;
    } catch {
      return "Nu s-a putut conecta la server.";
    }
  };

  // ── Register — la fel, userul vine direct din răspuns
  const register = async (email, password, name) => {
    try {
      const res = await fetch(`${API}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, name }),
      });
      const data = await res.json();
      if (!res.ok) return data.error || "Eroare la înregistrare.";

      if (data.token) {
        localStorage.setItem("narratiq_token", data.token);
        setUser(data.user);
        setSubscription(null);
      }
      return null;
    } catch {
      return "Nu s-a putut conecta la server.";
    }
  };

  // ── Logout
  const logout = () => {
    localStorage.removeItem("narratiq_token");
    setUser(null);
    setSubscription(null);
  };

  const getToken = () => localStorage.getItem("narratiq_token");

  const hasAccess = (tier) => {
    if (tier === "freemium") return true;
    if (user?.role === "admin") return true; 
    if (!user || !subscription) return false;
    if (subscription.status !== "active") return false;
    if (subscription.expires_at && new Date(subscription.expires_at) < new Date()) return false;
    if (subscription.tier !== tier) return false;
    if (subscription.type === "per_report") {
      return subscription.reports_used < subscription.reports_total;
    }
    return true;
  };

  const isAdmin = user?.role === "admin";

  return (
    <AuthContext.Provider value={{
      user, subscription, loading,
      login, register, logout, getToken,
      hasAccess, isAdmin,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
